// DEPENDENCIES
import React from "react";

// MUI COMPONENTS
import { Alert, Button, CircularProgress } from "@mui/material";

// What BQE did with each change
const WRITES = [
	{ status: "created", one: "new entry", many: "new entries" },
	{ status: "updated", one: "change", many: "changes" },
	{ status: "deleted", one: "deletion", many: "deletions" },
];
const PROBLEMS = {
	conflict: "Skipped",
	locked: "Skipped",
	error: "Not saved",
	pending: "Still saving",
};

// Body of the Send to BQE dialog: sending → what BQE did
export default function SendDialogBody({ posting, describe, onClose }) {
	const { phase, results = [], error } = posting;

	if (phase === "posting") {
		return (
			<p className="teDialogText teSend-busy">
				<CircularProgress size={18} />
				Sending to BQE…
			</p>
		);
	}

	const count = (status) => results.filter((r) => r.status === status).length;
	const writes = WRITES.filter((w) => count(w.status));
	const problems = results.filter((r) => PROBLEMS[r.status]);
	const merged = results.filter((r) => r.merged && r.status === "updated");
	const summary = writes
		.map((w) => {
			const n = count(w.status);
			return n + " " + (n === 1 ? w.one : w.many);
		})
		.join(", ");

	return (
		<>
			{error ? (
				<Alert severity="error">{error}</Alert>
			) : (
				<Alert severity={problems.length ? "warning" : "success"}>
					{writes.length
						? "BQE saved " + summary + "."
						: "Nothing was saved to BQE."}
				</Alert>
			)}

			{merged.length > 0 && (
				<Alert severity="info">
					{merged.map((r) => (
						<div key={describe(r)}>
							{describe(r)}: {r.merged} BQE entries were combined
							into one.
						</div>
					))}
				</Alert>
			)}

			{problems.length > 0 && (
				<ul className="teSend-problems">
					{problems.map((r) => (
						<li key={describe(r)}>
							<strong>{PROBLEMS[r.status]}:</strong> {describe(r)}
							<span className="teSend-reason">{r.message}</span>
						</li>
					))}
				</ul>
			)}

			<div className="dialogButtons">
				<Button variant="contained" disableElevation onClick={onClose}>
					Close
				</Button>
			</div>
		</>
	);
}
